import { render, staticRenderFns } from "./UserSessionsCard.vue?vue&type=template&id=13e7517e&scoped=true"
import script from "./UserSessionsCard.vue?vue&type=script&lang=js"
export * from "./UserSessionsCard.vue?vue&type=script&lang=js"
import style0 from "./UserSessionsCard.vue?vue&type=style&index=0&id=13e7517e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e7517e",
  null
  
)

export default component.exports